var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',[(_vm.hasBackButton)?_c('span',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("<")]):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"actions"},[_vm._t("actions")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }